/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles, Typography } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ButtonGroup from 'components/ButtonGroup';
import RefreshButton from 'components/RefreshButton';
import i18n from 'i18n';
import {
  getAllModelsRequest,
  registerModelRequest,
  removeMultipleModelsRequest,
} from 'modules/environments/actions';
import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import ApplicationState from 'store/interfaces';
import { PermissionsData } from 'modules/authenticate/interfaces';
import { EnvironmentFields } from 'modules/environments/interfaces';
import { TableCellHeaderProps } from 'components/TableItems/interfaces';
import Button from 'components/Button';
import { useTableFilters } from 'hooks/useTableFilters';
import PageTitle from 'components/PageTitle';
import { SearchBar } from 'components/SearchBar';
import FormModel from './FormModel';
import styles from './styles';
import ModelsTable from './ModelsTable';

const useStyles = makeStyles(styles);

const initialQuery = {
  offset: 0,
  limit: 25,
  search: '',
};

interface Props {
  environmentSelected: EnvironmentFields | null;
  isLoading: boolean;
  permissions: PermissionsData | undefined;
  getAllModelsRequest: (props: { id: string; query: any }) => void;
  registerModelRequest: (props: {
    id: string;
    values: any;
    pathUrl: string;
  }) => void;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
  removeMultipleModelsRequest: (props: {
    id: string;
    query: any;
    modelsIds: string[];
  }) => void;
}

const InstancesList = ({
  environmentSelected,
  isLoading,
  permissions,
  getAllModelsRequest,
  registerModelRequest,
  modalOpen,
  modalClose,
  removeMultipleModelsRequest,
}: Props) => {
  const classes = useStyles();

  const {
    query,
    setQuery,
    searchValue,
    handleSearch,
    setSearchValue,
  } = useTableFilters(initialQuery);

  const { id } = useParams<{ id: string }>();
  const [refresh, setRefresh] = React.useState(false);
  const [checks, setChecks] = React.useState<string[]>([]);

  const getModels = (refresh = false) => {
    getAllModelsRequest({ id, query });
    setRefresh(refresh);
  };

  React.useEffect(() => {
    getModels();
  }, [id, query]);

  const getModalContent = () => {
    if (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      checks?.includes(environmentSelected?.scale_instances?.main_model_uuid!)
    ) {
      return (
        <>
          <Typography>
            {i18n.t('ENVIRONMENTS_PAGE.REMOVE_MULTIPLE_MODELS_KEY')}
          </Typography>
          <Grid className={classes.warning}>
            <InfoOutlinedIcon
              fontSize="small"
              className={classes.warningIcon}
            />
            <Typography className={classes.warningText}>
              {i18n.t('ENVIRONMENTS_PAGE.REMOVE_MULTIPLE_MODELS_WARNING_KEY')}
            </Typography>
          </Grid>
        </>
      );
    }
    return i18n.t('ENVIRONMENTS_PAGE.REMOVE_MULTIPLE_MODELS_KEY');
  };

  const handleRemoveMultipleModels = () => {
    modalOpen({
      title: i18n.t('REMOVE_MODELS_SELECTED_KEY'),
      content: getModalContent(),
      maxWidth: 'sm',
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              removeMultipleModelsRequest({
                id,
                query,
                modelsIds: checks,
              });
              modalClose();
            }}
          >
            {i18n.t('DELETE_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  const headers: Array<TableCellHeaderProps> = React.useMemo(
    () => [
      { key: 'nome_base', i18n: 'BASE_NAME_KEY', order: true },
      { key: 'version', i18n: 'VERSION_KEY', centerTitle: true, order: true },
      {
        key: 'creation_date',
        i18n: 'DATE_KEY',
        order: true,
        centerTitle: true,
      },
      { key: 'model_type', i18n: 'TYPE_KEY', order: true, centerTitle: true },
      { key: 'flavor', i18n: 'FLAVOR_KEY', order: true },
      {
        key: 'active_instances',
        i18n: 'ACTIVE_INSTANCES_KEY',
        centerTitle: true,
        order: true,
      },
      {
        key: 'connected_users',
        i18n: 'CONNECTED_USERS_KEY',
        centerTitle: true,
        order: true,
      },
    ],
    []
  );

  return (
    <>
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="space-between"
        className={classes.header}
      >
        <Grid item className={classes.actionsGrid}>
          <PageTitle
            title={i18n.t('ENVIRONMENTS_PAGE.LIST_MODELS_TITLE_KEY')}
            subtitle={i18n.t('ENVIRONMENTS_PAGE.LIST_MODELS_SUBTITLE_KEY')}
          />
        </Grid>
        <Grid item className={classes.actionsGrid}>
          <RefreshButton
            id="btn-refresh"
            onClick={() => getModels(true)}
            animate={isLoading}
            className={classes.refreshButton}
            disabled={isLoading}
          />
          <ButtonGroup
            style={{ marginLeft: 16 }}
            label={i18n.t('GENERAL_ACTIONS_KEY')}
            options={[
              {
                label: i18n.t('ADD_MODEL_KEY'),
                hidden: !!permissions && !permissions.create_models,
                onClick: () =>
                  modalOpen({
                    maxWidth: 'md',
                    title: i18n.t('CREATE_MODEL_KEY'),
                    content: (
                      <FormModel
                        onSubmit={({ values, pathUrl }) => {
                          registerModelRequest({ id, values, pathUrl });
                        }}
                        onCancel={modalClose}
                        cloud={environmentSelected?.provider?.type}
                      />
                    ),
                  }),
              },
              {
                label: i18n.t('REMOVE_MODELS_SELECTED_KEY'),
                disabled: checks.length === 0,
                hidden: !!permissions && !permissions.delete_models,
                onClick: handleRemoveMultipleModels,
              },
            ]}
          />
        </Grid>
      </Grid>

      <Grid container>
        <SearchBar
          id="search-models"
          isLoading={isLoading}
          searchValue={searchValue}
          handleSearch={handleSearch}
          setSearchValue={setSearchValue}
        />

        <ModelsTable
          refresh={refresh}
          checks={checks}
          setChecks={setChecks}
          ambUuid={id}
          query={query}
          setQuery={setQuery}
          headers={headers}
        />
      </Grid>
    </>
  );
};

const mapStateToProps = ({
  authenticate: { data },
  environments: { isLoading, environmentSelected },
}: ApplicationState) => ({
  isLoading,
  permissions: data?.permissions,
  environmentSelected,
});

export default connect(mapStateToProps, {
  getAllModelsRequest,
  registerModelRequest,
  modalOpen,
  modalClose,
  removeMultipleModelsRequest,
})(InstancesList);
